export default "__VITE_ASSET__BNZDyhp6__"